import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; // Adjust the API instance import as per your setup
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const AddTaxes = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // Validate form fields
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
          tax_name: formData.name,
          tax_percent: formData.percentage,
          outside: formData.outside === "YES" ? 1 : 0,
          status: formData.status === true ? 1 : 0,
        };

        const response = await axiosInstance.post("/tax/create", payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          await Swal.fire({
            title: "Success",
            text: "Tax added successfully.",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          navigate("/admin/manage-logistic/taxes");
        }
      } catch (error) {
        console.error("Error submitting form:", error);

        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while processing your request.";
        await Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const CustomerInputs = [
    {
      name: "name",
      label: "Tax Name",
      type: "text",
      required: true,
      placeholder: "Enter Tax Name",
      gridClass: "col-lg-4",
      validation: validations.taxName({ required: true }),
    },
    {
      name: "percentage",
      label: "Tax percentage",
      placeholder: "Enter Tax Percentage",
      type: "number",
      isDecimal: true,
      required: true,
      gridClass: "col-lg-4",
      validation: validations.percentage({ required: true }),
    },
    {
      name: "outside",
      label: "Government Tax?",
      type: "dropdown",
      required: true,
      options: [
        { label: "YES", value: "YES" },
        { label: "NO", value: "NO" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Tax</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Tax Details
              </span>
              <DynamicForm
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(CustomerInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  CustomerInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddTaxes;
